var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_9481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V24H0",
    fill: "#B31942"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 3.8426H0V2H32V3.8426ZM0 5.63148H32V7.47408H0V5.63148ZM32 11.1056H0V9.26296H32V11.1056ZM0 12.8944H32V14.737H0V12.8944ZM32 18.3685H0V16.5259H32V18.3685ZM0 20.1574H32V22H0V20.1574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H17.6V12.9231H0",
    fill: "#0A3161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46674 0.553711L1.88557 1.8896L0.789063 1.06397H2.14441L1.04791 1.8896L1.46674 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46674 3.13833L1.88557 4.47422L0.789062 3.64859H2.14441L1.04791 4.47422L1.46674 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46674 5.72294L1.88557 7.05883L0.789062 6.23321H2.14441L1.04791 7.05883L1.46674 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46674 8.30755L1.88557 9.64344L0.789062 8.81782H2.14441L1.04791 9.64344L1.46674 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46674 10.8922L1.88557 12.2281L0.789062 11.4024H2.14441L1.04791 12.2281L1.46674 10.8922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93341 1.84602L3.35223 3.18191L2.25573 2.35628H3.61108L2.51458 3.18191L2.93341 1.84602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93341 4.43063L3.35223 5.76652L2.25573 4.9409H3.61108L2.51458 5.76652L2.93341 4.43063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93341 7.01525L3.35223 8.35114L2.25573 7.52551H3.61108L2.51458 8.35114L2.93341 7.01525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93341 9.59986L3.35223 10.9357L2.25573 10.1101H3.61108L2.51458 10.9357L2.93341 9.59986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40007 0.553711L4.8189 1.8896L3.7224 1.06397H5.07775L3.98125 1.8896L4.40007 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40007 3.13833L4.8189 4.47422L3.7224 3.64859H5.07775L3.98125 4.47422L4.40007 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40007 5.72294L4.8189 7.05883L3.7224 6.23321H5.07775L3.98125 7.05883L4.40007 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40007 8.30755L4.8189 9.64344L3.7224 8.81782H5.07775L3.98125 9.64344L4.40007 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40007 10.8922L4.8189 12.2281L3.7224 11.4024H5.07775L3.98125 12.2281L4.40007 10.8922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86674 1.84602L6.28556 3.18191L5.18906 2.35628H6.54441L5.44791 3.18191L5.86674 1.84602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86674 4.43063L6.28557 5.76652L5.18906 4.9409H6.54441L5.44791 5.76652L5.86674 4.43063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86674 7.01525L6.28557 8.35114L5.18906 7.52551H6.54441L5.44791 8.35114L5.86674 7.01525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86674 9.59986L6.28557 10.9358L5.18906 10.1101H6.54441L5.44791 10.9358L5.86674 9.59986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 0.553711L7.75223 1.8896L6.65573 1.06397H8.01108L6.91458 1.8896L7.33341 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3334 3.13833L7.75223 4.47422L6.65573 3.64859H8.01108L6.91458 4.47422L7.3334 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3334 5.72294L7.75223 7.05883L6.65573 6.23321H8.01108L6.91458 7.05883L7.3334 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3334 8.30755L7.75223 9.64344L6.65573 8.81782H8.01108L6.91458 9.64344L7.3334 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3334 10.8922L7.75223 12.2281L6.65573 11.4024H8.01108L6.91458 12.2281L7.3334 10.8922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80007 1.84602L9.2189 3.18191L8.1224 2.35628H9.47775L8.38124 3.18191L8.80007 1.84602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80007 4.43063L9.2189 5.76652L8.1224 4.9409H9.47775L8.38125 5.76652L8.80007 4.43063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80007 7.01525L9.2189 8.35114L8.1224 7.52551H9.47775L8.38125 8.35114L8.80007 7.01525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80007 9.59986L9.2189 10.9358L8.1224 10.1101H9.47775L8.38125 10.9358L8.80007 9.59986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 0.553711L10.6856 1.8896L9.58906 1.06397H10.9444L9.84791 1.8896L10.2667 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 3.13833L10.6856 4.47422L9.58906 3.64859H10.9444L9.84791 4.47422L10.2667 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 5.72294L10.6856 7.05883L9.58906 6.23321H10.9444L9.84791 7.05883L10.2667 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 8.30755L10.6856 9.64344L9.58906 8.81782H10.9444L9.84791 9.64344L10.2667 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 10.8922L10.6856 12.2281L9.58906 11.4024H10.9444L9.84791 12.2281L10.2667 10.8922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 1.84602L12.1522 3.18191L11.0557 2.35628H12.4111L11.3146 3.18191L11.7334 1.84602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 4.43063L12.1522 5.76652L11.0557 4.9409H12.4111L11.3146 5.76652L11.7334 4.43063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 7.01525L12.1522 8.35114L11.0557 7.52551H12.4111L11.3146 8.35114L11.7334 7.01525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 9.59986L12.1522 10.9358L11.0557 10.1101H12.4111L11.3146 10.9358L11.7334 9.59986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 0.553711L13.6189 1.8896L12.5224 1.06397H13.8778L12.7812 1.8896L13.2001 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 3.13833L13.6189 4.47422L12.5224 3.64859H13.8777L12.7812 4.47422L13.2001 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 5.72294L13.6189 7.05883L12.5224 6.23321H13.8777L12.7812 7.05883L13.2001 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 8.30755L13.6189 9.64344L12.5224 8.81782H13.8777L12.7812 9.64344L13.2001 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 10.8922L13.6189 12.2281L12.5224 11.4024H13.8777L12.7812 12.2281L13.2001 10.8922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.84602L15.0856 3.18191L13.9891 2.35628H15.3444L14.2479 3.18191L14.6667 1.84602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.43063L15.0856 5.76652L13.9891 4.9409H15.3444L14.2479 5.76652L14.6667 4.43063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.01525L15.0856 8.35114L13.9891 7.52551H15.3444L14.2479 8.35114L14.6667 7.01525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.59986L15.0856 10.9358L13.9891 10.1101H15.3444L14.2479 10.9358L14.6667 9.59986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 0.553711L16.5522 1.8896L15.4557 1.06397H16.8111L15.7146 1.8896L16.1334 0.553711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 3.13833L16.5522 4.47422L15.4557 3.64859H16.8111L15.7146 4.47422L16.1334 3.13833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 5.72294L16.5522 7.05883L15.4557 6.23321H16.8111L15.7146 7.05883L16.1334 5.72294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 8.30755L16.5522 9.64344L15.4557 8.81782H16.8111L15.7146 9.64344L16.1334 8.30755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 10.8922L16.5522 12.2281L15.4557 11.4024H16.8111L15.7146 12.2281L16.1334 10.8922Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_9481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.92247e8abbd59ffcd95aeaaa21c4e30e.svg";
export { ForwardRef as ReactComponent };